import { render, staticRenderFns } from "./OtpVerification.vue?vue&type=template&id=1a78b82a&scoped=true"
import script from "./OtpVerification.vue?vue&type=script&lang=ts"
export * from "./OtpVerification.vue?vue&type=script&lang=ts"
import style0 from "./OtpVerification.vue?vue&type=style&index=0&id=1a78b82a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a78b82a",
  null
  
)

export default component.exports